import createVueApp from '@/common/create_app'

Styxie.Initializers.MlapSettingsGeogrids = {
  index: async(props) => {
    const { default: GeogridsSettings } = await import('@/vue_widgets/mlap/settings/geogrids/index.vue')
    createVueApp(GeogridsSettings, { props })
  }
}
